import { AppConfigModel } from "../../abstract/app-config.model";

export class LoanRepaymentProfile extends AppConfigModel {

    static override CLASS_NAME: string = 'LoanRepaymentProfile';
}
